import { combineReducers } from 'redux';
import UserUidCode from './reducers'

const rootReducer  = combineReducers({
    UserUidCode,
})

export default rootReducer;
